import pageStyles from "../components/ui/PageBox.module.css";
import styles from "./ChildSafetyPolicyPage.module.css";

export default function ChildSafetyPolicyPage() {
  return (
    <div className={pageStyles.pageBox}>
      <h1 className={styles.page_title}>네스톡 아동 안전 및 보호 정책</h1>
      <div className={styles.page_content}>
        <h3 className={styles.title}>1. 서론</h3>
        <p className={styles.subarticle}>
          네스톡은 모든 사용자에게 안전한 환경을 제공하기 위해 최선을 다하고
          있으며, 특히 아동 보호를 최우선으로 고려합니다. 우리는 아동 성적 학대
          및 착취(CSAE)를 방지하고, 관련 법규와 Google의 아동 안전 표준 정책을
          준수합니다.
        </p>
        <h3 className={styles.title}>2. 아동 성적 학대 및 착취(CSAE) 방지</h3>
        <p className={styles.subtitle}>
          네스톡은 아동을 보호하고 안전한 디지털 환경을 조성하기 위해 다음과
          같은 조치를 시행합니다.
        </p>
        <p className={styles.subarticle}>불법적이거나 부적절한 콘텐츠 차단</p>
        <p className={styles.subarticle}>사용자 신고 시스템 운영</p>
        <p className={styles.subarticle}>아동 보호 관련 법규 준수 및 협력</p>
        <p className={styles.subarticle}>의심스러운 활동 감지 및 대응</p>
        <h3 className={styles.title}>3. 신고 및 대응 절차</h3>
        <p className={styles.subtitle}>
          아동 관련 불법 콘텐츠나 부적절한 활동을 발견할 경우, 다음 방법으로
          신고할 수 있습니다.
        </p>
        <p className={styles.subarticle}>이메일: idealoftyke@nestock.net</p>
        <p className={styles.subarticle}>관련 기관: 국제실종아동센터(ICMEC)</p>
        <p className={styles.subarticle}>
          신고된 내용은 즉시 검토되며, 필요 시 법 집행 기관과 협력하여 조치를
          취합니다.
        </p>
        <h3 className={styles.title}>4. 정책 준수 및 업데이트</h3>
        <p className={styles.subarticle}>
          이 정책은 최신 법규 및 규정을 반영하여 주기적으로 업데이트됩니다. 정책
          변경 사항은 사용자에게 공지되며, 네스트록은 지속적으로 아동 보호
          강화를 위해 노력하겠습니다.
        </p>
      </div>
    </div>
  );
}
